const IconAppGrid = () => {
    return (
        <svg className="w-inherit h-inherit" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="36" height="36" rx="8" fill="#FFF0E6" />
            <rect x="5" y="5" width="11" height="11" rx="3" fill="#E8652A" />
            <rect x="20" y="5" width="11" height="11" rx="3" fill="#F0956A" />
            <rect x="5" y="20" width="11" height="11" rx="3" fill="#F0956A" />
            <rect x="20" y="20" width="11" height="11" rx="3" fill="#F7C4A8" />
        </svg>
    )
}

export default IconAppGrid